module.exports = __webpack_public_path__ + "assets/on-illegally-parked.daf0e35c.svg";